import React, { useEffect, useRef } from 'react';

import { Box, rem } from '@vimeo/bokeh';
import { Video } from '@vimeo/gctl-api/models/components/schemas/video/Video';
import { usePlayer } from '@vimeo/player';

import { idFromUri } from '../../utils';

interface CommentPreviewPlayerProps {
  previewClip: Video;
  onPlayerReady: () => void;
  height: number;
  width: number;
}

export const CommentPreviewPlayer = ({
  previewClip,
  onPlayerReady,
  height,
  width,
}: CommentPreviewPlayerProps) => {
  const playerElementRef = useRef<HTMLDivElement>(null);
  const { player } = usePlayer(
    playerElementRef,
    idFromUri(previewClip.uri),
    true,
    previewClip.embedPlayerConfigUrl ?? '',
    false,
  );

  useEffect(() => {
    if (player?.ready) {
      player.ready(() => {
        onPlayerReady();
        player.play();
      });
    }
  }, [player, onPlayerReady]);

  return (
    <Box position="relative" height={rem(height)} width={rem(width)}>
      <Box ref={playerElementRef} className="player js-player"></Box>
    </Box>
  );
};
